import * as Yup from "yup";

export const testimonialFormSchema = Yup.object().shape({
  status: Yup.string().required("Status is required"),
  description: Yup.string().required("Description is required"),
  desktop_banner: Yup.array().required("Desktop banner is required"),
  mobile_banner: Yup.array().required("Mobile banner is required"),
});
